export enum IconName {
  LOGO = 'logo',
  SECONDARY_LOGO = 'secondary-logo',
  CHECKED = 'checked',
  UNCHECKED = 'unchecked',
  LOGOWHITE = 'logowhite',
  YOUTUBE = 'youtube',
  TWITTER = 'twitter',
  INSTAGRAM = 'instagram',
  FACEBOOK_WHITE = 'facebook-white',
  FACEBOOK = 'facebook',
  LINKEDIN = 'linkedin',
  GOOGLE = 'google',
  LOGOHEADER = 'logoheader',
  APPLE = 'apple',
  TWT = 'twt',
  ARROWLEFT = 'arrowleft',
  ARROWRIGHT = 'arrowright',
  NOTIFY = 'notify',
  HOME = 'home',
  HOMEACTIVE = 'home-active',
  INVENTORY = 'inventory',
  INVENTORYACTIVE = 'inventory-active',
  CUSTOMERS = 'customers',
  CUSTOMERSACTIVE = 'customers-active',
  ORDERS = 'orders',
  ORDERSACTIVE = 'orders-active',
  STAFF = 'staff',
  STAFFACTIVE = 'staff-active',
  BRANDS = 'brands',
  BRANDSACTIVE= 'brandss-active',
  SETTINGS = 'settings',
  SETTINGSACTIVE = 'settings-active',
  SHOPS = 'shops',
  SHOPSACTIVE = 'shops-active',
  ADMINS = 'admins',
  ADMINSACTIVE = 'admins-active',
  PAYMENTS = 'payments',
  PAYMENTSACTIVE = 'payments-active',
  CONTENT = 'content',
  CONTENTACTIVE = 'content-active',
  CLOSE = 'close',
  CLOSE_SM = 'close-sm',
  PROFILE = 'profile',
  LOGOUT = 'logout',
  PC = 'pc',
  MOBILE = 'mobile',
  FILTER = 'filter',
  SCAN = 'scan',
  EXPORT = 'export',
  PLUS = 'plus',
  TRAFFICARROW = 'traffic_arrow',
  EDIT = 'edit',
  ARROW_RIGHT = 'arrow-right',
  ARROW_LEFT = 'arrow-left',
  UPLOAD = 'upload',
  FAIL = 'fail',
  CROSS = 'cross',
  LOADER = 'loader',
  STAR_LABEL_REQUIRED = 'star-label-required',
  VISA = 'visa',
  MASTER_CARD = 'mastercard',
  PAYMENT_CARD_TYPE_VISA = 'payment-card-type-visa',
  PAYMENT_CARD_TYPE_MASTERCARD = 'payment-card-type-mastercard',
  PAYMENT_CARD_TYPE_UNKNOWN = 'payment-card-type-unknown',
  PLUS_PAYMENT = 'plus_payment',
  EDIT_PAYMENT = 'edit_payment',
  PASSWORD_HINT_CHECK = 'hintcheck',
  PASSWORD_HINT_CROSS = 'hintcross',
  PASSWORD_EYE = 'eye',
  PASSWORD_EYE_HIDE = 'eye-hide',
  ARROW_UP_DOWN = 'arrow-up-down',
  COMPUTER = 'computer',
  SMARTPHONE = 'smartphone',
  ACTIVE_SESSIONS_CROSS = 'active_sessions_cross',
  ACTIVE_SESSIONS_SUCCESS = 'active-sessions-success',
  FAILURE = 'failure',
  MODAL_CROSS = 'modal-cross',
  SUCCESS = 'success',
  PENCIL = 'pencil',
  TRASH = 'trash',
  ELLIPSIS_VERTICAL = 'ellipsis-vertical',
  CHEVRON_UP = 'chevron-up',
  CHEVRON_DOWN = 'chevron-down',
  VIEW_DETAILS = 'view-details',
  EDIT_PENCIL = 'edit-pencil',
  ARROW_LEFT_2 = 'arrow-left-2',
  FILE = 'file',
  SECONDARY_CROSS = 'secondary-cross',
  FILE_INVALID_STATE = 'file-invalid-state',
  GRIP_VERTICAL = 'grip-vertical',
  TRASH_BIN_LIGHT = 'trash-bin',
  ADD_ANOTHER_PURPLE_PLUS = 'add-another-purple-plus',
  EMPRY_INVENTORY = 'empty-inventory',
  SEARCH = 'search',
  SORTABLE_ARROW = 'sortable-arrow',
  VIEW_ORDER = 'view-order',
  EDIT_STATUS = 'edit-status',
  PRINT_ORDER = 'print-order',
  PURPLE_CHECK = 'purple-check',
  CONFIRMATION_ICON = 'confirmation-icon',
  MAGNIFYING_GLASS = 'magnifying-glass',
  ERROR_ICON = 'error-icon',
  FEEDBACK = 'feedback',
  CVV_HINT_CARD = 'icon-cvv',
  CVV_HINT_TOOLTIP = 'icon-cvv-tooltip',
  DRAG_INDICATOR = 'drag-indicator',
  CALENDAR = 'calendar',
  ADD_IMAGE = 'add-images-icon'
}
